import Base from './Base';
import Conversation from './Conversation';
import moment from 'moment';
import { parsePhoneNumber } from 'libphonenumber-js';
import user from '../modules/user';
import inboxes from '../modules/inboxes';

export default class Contact extends Base {
    handleProperties(item) {
        // copy properties
        for (let key in item) {
            this[key] = item[key];
        }

        if (user.state.user) {
            this.user = user.state.user;
        }

        // update contact props
        if (this.integrationInfo) {
            this.email = this.integrationInfo.email || '';
            this.first_name = this.integrationInfo.first_name || '';
            this.last_name = this.integrationInfo.last_name || '';
            this.full_name = this.integrationInfo.full_name || '';
        }

        if (this.typeContact === 'pipedrive') {
            const phones = Array.isArray(this.integrationInfo.phones) ? this.integrationInfo.phones : [];
            const email = Array.isArray(this.integrationInfo.email) ? this.integrationInfo.email : [];
            const full_name = this.integrationInfo.full_name;

            this.phone = phones.length ? phones[0] : (this.integrationInfo.phone || '');
            this.email = email.length ? email[0] : '';
            this.first_name = this.integrationInfo.first_name || '';
            this.last_name =  this.integrationInfo.last_name || '';
            this.full_name = full_name || '';
        }

        if (this.typeContact === 'salesforce') {
            const phones = this.phones ? Object.values(this.phones) : [];
            this.phone = phones.length ? phones[0] : (this.integrationInfo.phone || '');
            this.mobile_phone = phones.length ? phones[1] : '';
            this.custom_phone = phones.length ? phones[2] : '';
        }

        // create custom properties
        if (!item.color) {
            this.color = this.generateColor;
        }

        if (!item.tags) {
            this.tags = [];
        }

        if (item.conversation) {
            this.conversation = new Conversation(item.conversation);
        }

        if (inboxes.state.inbox) {
            this.currentInbox = inboxes.state.inbox;
        }

        if (!item.area_code) {
            this.area_code = {};
        }

        if (Array.isArray(item.messages)) this.messages = item.messages;
        if (Array.isArray(item.messages_shortcode)) this.messages = item.messages_shortcode;
    }

    update(data) {
        for (let key in data) {
            switch (key) {
                case 'customFields': {
                    if (Array.isArray(this.custom_fields) && this.custom_fields.length) {
                        this['custom_fields'] = this['custom_fields'].map(item => {
                            const customFields = data?.customFields;
                            const hasField = customFields?.hasOwnProperty(item.field_key);
                            const value = customFields[item.field_key];

                            if (hasField) {
                                if (!item.value) item.value = {};

                                item.value.value = value;
                            }

                            return item;
                        });
                    }

                    break;
                }
                case 'custom_fields': {
                    if (!this.custom_fields || (Array.isArray(this.custom_fields) && !this.custom_fields.length)) {
                        this[key] = data[key];
                    }

                    break;
                }
                default: this[key] = data[key];
            }
        }

        return this;
    }

    get optInLocal() {
        return {
            disabled: this.opt_out === 'hard',
            id: 'local',
            name: 'Local and Toll-free Numbers',
            value: this.opt_out === null,
        };
    }

    get optInShortCode() {
        if (!Array.isArray(this.shortcode_opt_outs)) return [];

        return this.shortcode_opt_outs;
    }

    get optItems() {
        return [
            this.optInLocal,
            ...this.optInShortCode,
        ];
    }

    get hasOptIn() {
        return this.optInLocal.value;
    }

    get hasOptInCurrentInbox() {
        return !this.hasOptOutCurrentInbox;
    }

    get hasOptOut() {
        return !this.optInLocal.value;
    }

    get hasOptOutCurrentInbox() {
        if (!this.optInShortCode.length) return false;
        if (!this.currentInbox.isShortCode) return false;

        const numberId = this.currentInbox.number?.id;
        const optInShortCode = this.optInShortCode.find(item => item.number_id === numberId);

        if (!optInShortCode) return false;

        return !optInShortCode.value;
    }

    get showMessageLocal() {
        if (this.currentInbox.isShortCode) return false;

        return this.hasOptOut || this.hasOptOutCurrentInbox;
    }

    get showMessageAll() {
        if (this.currentInbox.isShortCode) {
            return this.hasOptOutCurrentInbox;
        }

        return this.optItems.length === this.optItems.filter(item => !item.value).length;
    }

    get fullName() {
        return this.full_name ? this.full_name : 'No Name';
    }

    get customFields() {
        if (!this.custom_fields) return [];

        return this.custom_fields.map(item => {
            item = {
                ...item,
                ...item.value
            };

            return item;
        });
    }

    get customFieldsVisible() {
        return this.customFields.filter(item => item.visible);
    }

    get customFieldsForForm() {
        const values = {};

        this.customFields.forEach(item => {
            values[item.field_key] = item.value;
        });

        return values;
    }

    get customFieldsDefaults() {
        const array = [
            {
                key: 'first_name',
                label: 'First Name',
                value: this.first_name,
            },
            {
                key: 'last_name',
                label: 'Last Name',
                value: this.last_name,
            },
            {
                key: 'email',
                label: 'E-Mail Address',
                value: this.email,
            },
            {
                key: 'phone',
                label: 'Phone Number',
                value: this.formatted_number,
            },
            {
                key: 'user_first_name',
                label: 'User First Name',
                value: this.user.first_name,
            },
            {
                key: 'user_last_name',
                label: 'User Last Name',
                value: this.user.last_name,
            },
            {
                key: 'user_email',
                label: 'User Email',
                value: this.user.email,
            },
        ];

        this.customFields.forEach(item => {
            array.push({
                key: item.field_key,
                label: item.name,
                value: item.value,
            });
        });

        return array.filter(item => item.value);
    }

    get name() {
        let output = '';

        let first_name = this.first_name || this.firstName;
        let last_name = this.last_name || this.lastName;
        let full_name = this.full_name;

        if (first_name) {
            output = first_name;

            if (last_name) {
                output += ' ' + last_name;
            }
        } else if (full_name) {
            output = full_name;
        } else if (this.email) {
            output = this.email;
        } else if (this.national_number) {
            output = this.national_number;
        } else if (this.phone) {
            output = this.phone;
        }

        return output ? output : false;
    }

    get integrationInfo() {
        if (!this.hasContactIntegration) return this;

        return this.hubspot || this.activecampaign || this.infusionsoft || this.pipedrive || this.salesforce;
    }

    get hasContactIntegration() {
        return Boolean(this.hubspot || this.activecampaign || this.infusionsoft || this.pipedrive || this.salesforce);
    }

    get hasContactHubSpot() {
        return this.typeContact === 'hubspot';
    }

    get hasContactActiveCampaign() {
        return this.typeContact === 'activecampaign';
    }

    get hasContactInfusionsoft() {
        return this.typeContact === 'infusionsoft';
    }

    get hasContactPipedrive() {
        return this.typeContact === 'pipedrive';
    }

    get hasContactSalesforce() {
        return this.typeContact === 'salesforce';
    }

    get hasIntegrationVendorId() {
        return Boolean(this.integration && this.integration.id && this.integration_vendor_id);
    }

    get hasIntegrationType() {
        return Boolean(this.integration_type);
    }

    get integrationContact() {
        if (this.hasIntegrationType) {
            return {
                ...this,
                type: this.integration_type,
            };
        }

        if (this.integration?.key) {
            return {
                ...this[this.integration.key],
                type: this.integration.key,
            };
        }

        return null;
    }

    get typeContact() {
        if (!this.integrationInfo.integration_type || !this.integration_type) return 'salesmsg';

        return this.integrationInfo.integration_type || this.integration_type;
    }

    get typeContactIntegration() {
        if (this.integration) return this.integration.key;
        if (!this.integrationInfo.integration_type) return 'salesmsg';

        return this.integrationInfo.integration_type;
    }

    get hasPhone() {
        return Boolean(this.phone || this.mobile_phone || this.national_number || this.number || this.custom_phone);
    }

    get phoneInfo() {
        return this.phone || this.mobile_phone || this.national_number || this.number || this.custom_phone || this.phones?.['Phone'] || this.phones?.['Mobile Phone'] || this.phones?.['Custom Phone'];
    }

    get phoneNumbers() {
        const phones = [];

        if (this.integrationInfo.phone) phones.push({
            field: 'Phone',
            type: 'phone',
            number: this.integrationInfo.phone,
        });

        if (this.integrationInfo.mobile_phone) phones.push({
            field: 'Mobile Phone',
            type: 'mobilephone',
            number: this.integrationInfo.mobile_phone,
        });

        if (this.integrationInfo.phones?.['Mobile Phone']) phones.push({
            field: 'Mobile Phone',
            type: 'mobilephone',
            number: this.integrationInfo.phones?.['Mobile Phone'],
        });

        if (this.integrationInfo.phones?.['Phone']) phones.push({
            field: 'Phone',
            type: 'phone',
            number: this.integrationInfo.phones?.['Phone'],
        });

        if (this.integrationInfo.phones?.['Custom Phone']) phones.push({
            field: 'Custom Phone',
            type: 'customphone',
            number: this.integrationInfo.phones?.['Custom Phone'],
        });

        return phones;
    }

    get hasPhoneNumbers() {
        return Boolean(this.phoneNumbers.length);
    }

    get phoneCount() {
        const phones = [];

        if (this.phone) phones.push(this.phone);
        if (this.mobile_phone) phones.push(this.mobile_phone);
        if (this.custom_phone) phones.push(this.custom_phone);

        return phones.length;
    }

    get generateColor() {
        const colors = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return colors[+this.id % colors.length];
    }

    get hasConversation() {
        return Boolean(
            !Array.isArray(this.conversation) && this.conversation && this.conversation.id
        );
    }

    get formattedCreatedAt() {
        return moment(this.created_at).format('MM/DD/YYYY h:mm A');
    }

    formattedDateAt(time) {
        if (!this.user.timezone) {
            return moment.utc(time).format('D MMM, YYYY - h:mm A');
        }

        return moment.utc(time).tz(this.user.timezone).format('D MMM, YYYY - h:mm A');
    }

    formattedCustomFieldPattern(time) {
        if (!this.user.timezone) {
            return moment.utc(time).format('D MMM, YYYY');
        }

        return moment.utc(time).tz(this.user.timezone).format('D MMM, YYYY');
    }

    formattedCustomFieldDate(value, type) {
        return type === 'date' ? this.formattedCustomFieldPattern(value) : value;
    }

    handleCustomField(key, type) {
        const customField = this.customFields.find(item => item.field_key === key);

        return customField && customField.value ? this.formattedCustomFieldDate(customField.value, type) : '-';
    }

    formattedLookupType(lookupType) {
        const lineTypesMap = {
            fixedVoip: 'Fixed VOIP',
            nonFixedVoip: 'Non Fixed VOIP',
            landline: 'Landline',
            mobile: 'Mobile',
            voip: 'VOIP',
            personal: 'Personal',
            tollFree: 'Toll-Free',
            premium: 'Premium',
            sharedCost: 'Shared Cost',
            uan: 'UAN',
            voicemail: 'Voicemail',
            pager: 'Pager',
            unknown: 'Unknown',
            undefined: 'Unavailable',
        };
        return lineTypesMap[lookupType] || '-';
    }

    formattedSourceName(source) {
        let sourceName = '-';

        switch (source) {
            case 'inbound_call':
                sourceName = 'Inbound Call';
                break;
            case 'inbound_sms':
                sourceName = 'Inbound SMS';
                break;
            case 'import':
                sourceName = 'Import';
                break;
            case 'keyword':
                sourceName = 'Keyword';
                break;
            case 'manual':
                sourceName = 'Manually';
                break;
            case 'website_chat':
                sourceName = 'Web Chat Widget';
                break;
            case 'api':
                sourceName = 'API';
                break;
            case 'activecampaign':
            case 'activecampaign_trigger':
                sourceName = 'ActiveCampaign';
                break;
            case 'aircall':
                sourceName = 'AirCall';
                break;
            case 'hubspot':
            case 'hubspot_trigger':
                sourceName = 'HubSpot';
                break;
            case 'infusionsoft':
            case 'infusionsoft_trigger':
                sourceName = 'Keap';
                break;
            case 'pipedrive':
                sourceName = 'Pipedrive';
                break;
            case 'slack':
                sourceName = 'Slack';
                break;
            case 'zapier':
                sourceName = 'Zapier';
                break;
            case 'salesforce':
            case 'salesforce_trigger':
            case 'salesforce_send_message_action':
                sourceName = 'Salesforce';
                break;
            case 'workflow':
                sourceName = 'Workflow';
            default:
        }

        return sourceName;
    }

    handleField(fieldData, key) {
        const data = {
            area_code: fieldData.area_code.area_code || '-',
            state_code: fieldData.area_code.state_code || '-',
            country: fieldData.country || '-',
            time_zone: fieldData.area_code.time_zone || '-',
            is_invalid: fieldData.is_invalid ? 'Invalid' : 'Valid',
            lookup_type: fieldData.lookup_type ? this.formattedLookupType(fieldData.lookup_type) : '-',
            carrier_name: fieldData.carrier_name || '-',
            updated_at: fieldData.updated_at ? this.formattedDateAt(fieldData.updated_at) : '-',
            last_called_on: fieldData.last_called_on ? this.formattedDateAt(fieldData.last_called_on) : '-',
            last_messaged_on: fieldData.last_messaged_on ? this.formattedDateAt(fieldData.last_messaged_on) : '-',
            last_contacted_on: fieldData.last_contacted_on ? this.formattedDateAt(fieldData.last_contacted_on) : '-',
            last_message_sent_on: fieldData.last_message_sent_on ? this.formattedDateAt(fieldData.last_message_sent_on) : '-',
            last_message_received_on: fieldData.last_message_received_on ? this.formattedDateAt(fieldData.last_message_received_on) : '-',
            message_status: fieldData.message_status || '-',
            opt_in: fieldData.opt_in || '-',
            opt_out_at: fieldData.opt_out_at ? this.formattedDateAt(fieldData.opt_out_at) : '-',
            total_received_sms: fieldData.total_received_sms || '-',
            total_received_call: fieldData.total_received_call || '-',
            shortcode: fieldData.shortcode || '-',
            segments: fieldData.segments || '-',
            source: fieldData.source ? this.formattedSourceName(fieldData.source) : '-',
        };

        return data[key];
    }

    get data() {
        return {
            color: this.color,
            country: this.country,
            country_calling_code: this.country_calling_code,
            created_at: this.created_at,
            custom_fields: this.custom_fields,
            email: this.email,
            first_name: this.first_name,
            formatted_number: this.formatted_number,
            full_name: this.full_name,
            id: this.id,
            integration: this.integration,
            integration_vendor_id: this.integration_vendor_id,
            integration_vendor_type: this.integration_vendor_type,
            last_name: this.last_name,
            national_number: this.national_number,
            number: this.number,
            opt_in_at: this.opt_in_at,
            opt_in_request_at: this.opt_in_request_at,
            opt_in_requests: this.opt_in_requests,
            opt_out: this.opt_out,
            opt_out_at: this.opt_out_at,
            owner_id: this.owner_id,
            photo_url: this.photo_url,
            prevent_autolink: this.prevent_autolink,
            tags: this.tags,
            updated_at: this.updated_at,
            name: this.name,
        };
    }

    get dataDraft() {
        return {
            color: this.color,
            country: this.country,
            country_calling_code: this.country_calling_code,
            created_at: this.created_at,
            custom_fields: this.custom_fields,
            email: this.email,
            first_name: this.first_name,
            formatted_number: this.formatted_number,
            full_name: this.full_name,
            id: this.id,
            integration: this.integration,
            integration_vendor_id: this.integration_vendor_id,
            integration_vendor_type: this.integration_vendor_type,
            last_name: this.last_name,
            national_number: this.national_number,
            number: this.number,
            opt_in_at: this.opt_in_at,
            opt_in_request_at: this.opt_in_request_at,
            opt_in_requests: this.opt_in_requests,
            opt_out: this.opt_out,
            opt_out_at: this.opt_out_at,
            owner_id: this.owner_id,
            photo_url: this.photo_url,
            prevent_autolink: this.prevent_autolink,
            tags: this.tags,
            updated_at: this.updated_at,
        };
    }

    get jsonData() {
        return JSON.stringify(this.data);
    }

    get isBlocked() {
        return this.is_blocked;
    }

    get isBlockedLabel() {
        return this.is_blocked ? 'Unblock' : 'Block';
    }

    get phoneNumberFormatted() {
        const phone = this.number || this.phone;
        return phone && parsePhoneNumber(phone.replace(/[^0-9\s+\-()]/g, ''), 'US').nationalNumber;
    }

    get phoneNumberFormatInternational() {
        const phone = this.number || this.phone;
        return phone && parsePhoneNumber(phone, 'US').formatInternational();
    }

    get phoneNumberFormatNational() {
        const phone = this.number || this.phone;
        return phone && parsePhoneNumber(phone, 'US').formatNational();
    }

    get mobileNumberFormatted() {
        const phone = this.mobile_phone;
        return phone && parsePhoneNumber(phone.replace(/[^0-9\s+\-()]/g, ''), 'US').nationalNumber;
    }

    get mobileNumberFormatInternational() {
        const phone = this.mobile_phone;
        return phone && parsePhoneNumber(phone, 'US').formatInternational();
    }

    get mobileNumberFormatNational() {
        const phone = this.mobile_phone;
        return phone && parsePhoneNumber(phone, 'US').formatNational();
    }

    get filters() {
        return {
            filtersList: [
                {
                    filters: [
                        {
                            key: 'number',
                            operator: 'contains',
                            value: this.formatted_number,
                        }
                    ]
                }
            ],
        };
    }

    keywordStatus() {
        if (this.is_subscribed) {
            return {
                class: 'has-background-success',
                label: 'Active',
            };
        }

        return {
            class: 'has-background-warning',
            label: 'Unsubscribed',
        };
    }
}
